import * as React from 'react'

export const Android = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={56}
      height={56}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.332 23.333v14M46.668 23.333v14M16.332 21h23.333v18.666A2.334 2.334 0 0137.332 42H18.665a2.334 2.334 0 01-2.333-2.334V21zm0 0a11.667 11.667 0 0123.333 0M18.668 7l2.333 4.667M37.333 7L35 11.667M21 42v7M35 42v7"
        stroke="#858585"
        strokeWidth={3.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
